import React, { Component, createRef } from "react";
import Modal from "react-bootstrap/Modal";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import ListSubheader from "@mui/material/ListSubheader";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import { createTheme, ThemeProvider, styled } from "@mui/material/styles";
import sweetAlert, {
  sweetStatusAlert,
} from "../../../../../components/common/SweetAlert.js";
import { Form } from "react-bootstrap";
import Checkbox from "@mui/material/Checkbox";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { faL } from "@fortawesome/free-solid-svg-icons";
import Button from "@mui/material/Button";
import { StudentService } from "../../../../../service/manage/registration/reg_c.service.js";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Levasto_Logo from "../../../../../assets/images/Levasto_Logo.png";
import SimpleReactValidator from "simple-react-validator";
import RegCDocSubmission from "./RegCDocSubmission.js";
import config from "../../../../../helper/config.js";
import { customerConstants } from "../../../../../helper/constants.js";
import { AzureStorageManage } from "../../../../../helper/azureStorageManage.js";
import {
  namespace,
  cgcDocSubmisBlobName,
  regCUploadTypes,
} from "../../../../../helper/namespace.js";


const lightTheme = createTheme({ palette: { mode: "light" } });

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  textAlign: "center",
  color: theme.palette.text.secondary,
  lineHeight: "40px",
  padding: theme.spacing(2), // Add padding
  marginBottom: theme.spacing(1),
  marginRight: theme.spacing(3),
}));

const getCustomerFeatureFlag = () => {
  return config.customerConfigs.featureFlag;
};
let cancelClass, confirmClass;
const customer = getCustomerFeatureFlag();
switch (customer) {
  case customerConstants.EXO_CUSTOMER1:
    cancelClass = "btn-default";
    confirmClass = "btn-primary";
    break;
  case customerConstants.EXO_CUSTOMER2:
  // cancelClass = "cmc-btn-default"
  // confirmClass = "cmc-btn-primary"
  default:
    cancelClass = "btn-default";
    confirmClass = "btn-primary";
    break;
}

class BlockLetterInput extends Component {
  constructor(props) {
    super(props);
    this.textRefs = Array.from({ length: this.props.values.length }, () =>
      createRef()
    );
  }

  handleChange = (e, index) => {
    const { values, setValues } = this.props;
    const newValues = [...values];
    newValues[index] = e.target.value.toUpperCase().slice(-1);
    setValues(newValues);

    if (index < this.textRefs.length - 1 && newValues[index]) {
      this.textRefs[index + 1].current.focus();
    }
  };

  handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && index > 0 && !this.props.values[index]) {
      const { values, setValues } = this.props;
      const newValues = [...values];
      newValues[index - 1] = "";
      setValues(newValues);
      this.textRefs[index - 1].current.focus();
    }
  };

  render() {
    const {
      values,
      label,
      refIndex,
      validationMessage,
      disbaleAllApplicatInputs,
    } = this.props;
    const lines = [];
    for (let i = 0; i < values.length; i += 20) {
      lines.push(values.slice(i, i + 20));
    }

    return (
      <Box sx={{ p: 2 }}>
        <Grid container alignItems="center" spacing={0.7}>
          <Grid item xs={2}>
            <Item
              elevation={0}
              sx={{
                fontWeight: "bold",
                height: "100%",
                backgroundColor: "#E0E8ED",
              }}
            >
              {label}
            </Item>
          </Grid>
          <Grid item xs={10}>
            {lines.map((line, lineIndex) => (
              <Box
                key={lineIndex}
                sx={{
                  borderRadius: 0,
                  display: "flex",
                  gap: 0.2,
                  marginBottom: 0.5,
                  height: "100%",
                  flexDirection: "column", // Adjusted to have validation message below the blocks
                }}
              >
                <Box sx={{ display: "flex", gap: 0.2 }}>
                  {line.map((value, index) => (
                    <TextField
                      key={index + lineIndex * 20}
                      value={value}
                      onChange={(e) =>
                        this.handleChange(e, index + lineIndex * 20)
                      }
                      onKeyDown={(e) =>
                        this.handleKeyDown(e, index + lineIndex * 20)
                      }
                      inputRef={
                        index + lineIndex * 20 === refIndex
                          ? this.props.forwardedRef
                          : this.textRefs[index + lineIndex * 20]
                      }
                      inputProps={{
                        maxLength: 1,
                        style: {
                          borderRadius: 0,
                          textTransform: "uppercase",
                          width: "4.8ch",
                          height: "5.5ch",
                          textAlign: "center",
                          backgroundColor: "#E0E8ED",
                          padding: "0px",
                        },
                      }}
                      sx={{
                        borderRadius: 0,
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 0, // Remove rounded corners
                        },
                      }}
                      disabled={disbaleAllApplicatInputs}
                    />
                  ))}
                </Box>
                {lineIndex === lines.length - 1 && (
                  <Typography
                    variant="body2"
                    sx={{ color: "red", textAlign: "left", mt: 0.5 }}
                  >
                    {validationMessage}
                  </Typography>
                )}
              </Box>
            ))}
          </Grid>
        </Grid>
      </Box>
    );
  }
}
export default class RegCAddStudentModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      isModified: false,
      showInsertModal: false,
      full_name: Array(60).fill(""),
      first_name: Array(20).fill(""),
      last_name: Array(20).fill(""),
      user_code: "",
      gender: "",
      dob: "",
      nic: "",
      mobile: "",
      email: "",
      home: "",
      status: 0,

      lg_user_id: sessionStorage.getItem("manage_user_id"),
      lg_user_table_id: sessionStorage.getItem("table_log_id"),

      uploadFiles: {
        selectedFilePhoto: [],
        selectedFileOther: [],
      },
      disbaleAllApplicatInputs: true,
      disableApplicantAcknowledge: true,
      disableApprove: true,

      formIsValid: false,
      user_approval: 0,
      info_approval: 0,
      officeSectionAvailability: false,
      hasFullPrivilege: this.checkFullPrivilege(),

      parent_name : "",
      parent_email: "",
      parent_number:"",
      reg_note:"",
      stream:"",
      school:""
    };

    this.createValidationsInstance();
    this.formInitialState = {
      isModified: false,
      isLoading: false,
      full_name: Array(60).fill(""),
      first_name: Array(20).fill(""),
      last_name: Array(20).fill(""),
      user_code: "",
      gender: "",
      dob: new Date(),
      nic: "",
      mobile: "",
      email: "",
      home: "",
      status: 0,
      uploadFiles: {
        selectedFilePhoto: [],
        selectedFileOther: [],
      },

      formIsValid: false,
      parent_name : "",
      parent_email: "",
      parent_number:"",
      reg_note:"",
      stream:"",
      school:""
    };
  }

  createValidationsInstance() {
    this.validator = new SimpleReactValidator({
      validators: {
        address: {
          message: "The :attribute must be a valid address",
          rule: (val, params, validator) => {
            return (
              validator.helpers.testRegex(val, /^[a-zA-Z-/:0-9,\s]+$/i) &&
              params.indexOf(val) === -1
            );
          },
          messageReplace: (message, params) =>
            message.replace(":values", this.helpers.toSentence(params)), // optional
        },
        dateBefore: {
          message: "The :attribute must be before current date",
          rule: (val, params, validator) => {
            const selectedDate = new Date(val);
            const currentDate = new Date();
            return selectedDate < currentDate;
          },
          messageReplace: (message, params) =>
            message.replace(":values", this.helpers.toSentence(params)), // optional
          required: true,
        },
        phone_number: {
          message: "The :attribute must be a valid phone number",
          rule: (val, params, validator) => {
            const isTenDigitsStartingWithZero =
              val.length === 10 && val.startsWith("0");
            const isNineDigits = val.length === 9 && !val.startsWith("0");
            return isTenDigitsStartingWithZero || isNineDigits;
          },
          messageReplace: (message, params) =>
            message.replace(":values", this.helpers.toSentence(params)), // optional
          required: true,
        },
      },
    });
    this.updateValidator = new SimpleReactValidator();
  }

  componentDidMount() {
    let privilege_edit = !!this.props.state.privilege_edit;
    let privilege_add = !!this.props.state.privilege_add;
    let privilege_delete = !!this.props.state.privilege_delete;
    this.setState({
      disbaleAllApplicatInputs: !privilege_edit && !privilege_add,
      disableApplicantAcknowledge:
        !privilege_edit || !this.validator.allValid(),
      disableApprove: !privilege_delete,
      officeSectionAvailability: privilege_delete || privilege_add,
    });
  }

  toggleAddStudentModal = () => {
    this.setState(
      (prevState) => ({
        showInsertModal: !prevState.showInsertModal,
        first_name: "",
        last_name: "",
        nic: "",
        dob: "",
        email: "",
        phone_number: "",
        gender_id: "",
        status_id: "",
        created_on: "",
        created_by: "",
        studentAddresses: [],
        grade: null,
        school: "",
        home:"",
        parent_name : "",
        parent_email: "",
        parent_number:"",
        reg_note:"",
        stream:"",
      }),
      () => {
        // State has changed, perform your logic here based on the state change
        if (this.state.showInsertModal) {
          //   this.getAllGrades();
          //   this.getAllStudentAddressTypes();
        }
      }
    );
  };

  handleSweetAlert = (toggleFunction, modalVisibility) => {
    if (this.state.isModified) {
      sweetAlert().then((response) => {
        this.setState(this.formInitialState);
        this.setState(() => ({
          [modalVisibility]: response,
          isModified: false,
        }));
        this.toggleAddStudentModal();
        toggleFunction();
      });
    } else {
      this.setState(this.formInitialState);
      this.toggleAddStudentModal();
      toggleFunction();
    }
  };

  updateFormValidity = () => {
    const formIsValid = this.validator.allValid();
    if (formIsValid) {
      this.setState({
        disableApplicantAcknowledge:
          !this.props.state.privilege_edit || !formIsValid,
      });
    }
    this.setState({ formIsValid });
  };

  handleChange = (event) => {
    const { name, type, checked, value } = event.target;
    const newValue = type === "checkbox" ? (checked ? 1 : 0) : value;
    this.setState({ [name]: newValue, isModified: true }, () => {
      this.updateFormValidity();
    });
  };


  handleBlockInputChangeFullName = (newValues) => {
    this.setState({ full_name: newValues }, () => {
      this.updateFormValidity();
    });
    const fullNameString = this.convertArrayToString(newValues);
  };

  handleBlockInputChangeFirstName = (newValues) => {
    this.setState({ first_name: newValues }, () => {
      this.updateFormValidity();
    });
    const firstNameString = this.convertArrayToString(newValues);
  };

  handleBlockInputChangeLastName = (newValues) => {
    this.setState({ last_name: newValues }, () => {
      this.updateFormValidity();
    });
    const lastNameString = this.convertArrayToString(newValues);
  };

  convertArrayToString = (arr) => {
    if (Array.isArray(arr)) {
      return arr.join("").trim();
    }
    return "";
  };

  handleUploadFiles = (uploadFiles) => {
    this.setState(
      {
        uploadFiles: uploadFiles,
      },
      () => {}
    );
  };

  // Helper function to read file as text
  readFile = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (event) => {
        resolve(event.target.result);
      };

      reader.onerror = (error) => {
        reject(error);
      };

      reader.readAsArrayBuffer(file);
    });
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    if (!this.validator.allValid()) {
      this.validator.showMessages();
      sweetStatusAlert("Warning!", "Please ensure all required fields are filled out correctly.", "warning");
      this.forceUpdate();
    } else {
      this.setState({ isLoading: true });
      const { dob } = this.state;
      if (!dob || dob === "") {
        sweetStatusAlert("Warning!", "Date of birth is required", "info");
        this.setState({ isLoading: false });
      } else {
        try {
          const {
            full_name,
            first_name,
            last_name,
            user_code,
            gender,
            dob,
            nic,
            mobile,
            email,
            home,
            parent_name,
            parent_email,
            parent_number,
            reg_note,
            stream,
            school,
            status
          } = this.state;

          
          const newRegStudent = {
            node_mid:
              !!this.props.state && !!this.props.state.mid
                ? this.props.state.mid
                : 100,
            full_name: this.convertArrayToString(full_name),
            first_name: this.convertArrayToString(first_name),
            last_name: this.convertArrayToString(last_name),
            user_code: user_code,
            gender: gender,
            dob: dob,
            nic: nic,
            mobile: mobile,
            email: email,
            address_1: home,
            parent_name:parent_name,
            parent_email: parent_email,
            parent_number:parent_number,
            reg_note:reg_note,
            stream:stream,
            school:school,
            status: status,
          };

          const studentResponse = await StudentService.create_reg_student(
            JSON.stringify(newRegStudent)
          );

          if (studentResponse.success) {
            let userData = {
              user_code: studentResponse.data.user_code,
              std_id: studentResponse.data.id_details[0],
              user_id: studentResponse.data.user_id,
              user_table_id: studentResponse.data.user_table_id,
            };
            this.onFileUpload(userData);
            this.setState({ isLoading: false });
            sweetStatusAlert(
              "Success!",
              "New student added successfully!",
              "success"
            );
            this.props.toggleAddStudentModal();
            this.setState(this.formInitialState);
          } else {
            sweetStatusAlert("Failed!", studentResponse.message, "error");
            this.setState({ isLoading: false });
          }
        } catch (e) {
          this.setState({ isLoading: false });
          sweetStatusAlert("Failed!", "Failed to create new student", "error");
        }
      }
    }
  };

  checkFullPrivilege = () => {
    const { privilege_edit, privilege_add, privilege_delete } =
      this.props.state;
    return privilege_edit && privilege_add && privilege_delete;
  };


  componentDidUpdate(prevProps) {
    if (prevProps.enrollments !== this.props.enrollments) {
      this.setState({ enrollments: this.props.enrollments });
    }
  }

  handleBlobsDetail = async (
    labelName,
    selectedFileType,
    user_code,
    std_id
  ) => {
    const { uploadFiles } = this.state;

    const form_list = this.props.state.form_list_id;
    let blobIds = [];
    if (!!uploadFiles[selectedFileType].length) {
      const typeBlobDetails = await Promise.all(
        uploadFiles[selectedFileType].map(async (file, index) => {
          const name_ = file[0]?.name;
          const blobId = cgcDocSubmisBlobName(
            name_,
            form_list,
            labelName,
            index,
            user_code,
            std_id
          );
          const readData = await this.readFile(file[0]);
          blobIds.push(blobId);
          return {
            blobData: readData,
            blobName: blobId,
          };
        })
      );
      return {
        typeBlobDetails: typeBlobDetails,
        typeIds: blobIds,
      };
    } else {
      return {
        typeBlobDetails: [],
        typeIds: blobIds,
      };
    }
  };

  onFileUpload = async ({ user_code, std_id, user_id, user_table_id }) => {
    const { lg_user_id, lg_user_table_id } = this.state;
    const form_list = this.props.state.form_list_id;
    let container_id = `${customer}_form${form_list}`
      .toLowerCase()
      .replace(/[^a-z0-9-]/g, "-")
      .replace(/^-+|-+$/g, "");
    const handleBlobsDetailPhoto = await this.handleBlobsDetail(
      "photo",
      "selectedFilePhoto",
      user_code,
      std_id
    );
    
    const handleBlobsDetailOther = await this.handleBlobsDetail(
      "other",
      "selectedFileOther",
      user_code,
      std_id
    );
    const blobDetailsAllType = await Promise.all([
      ...handleBlobsDetailPhoto.typeBlobDetails,
      ...handleBlobsDetailOther.typeBlobDetails,
    ]);
    try {
      await AzureStorageManage.multiUploadBlob(
        container_id,
        blobDetailsAllType
      );

      const obj = {
        user_id: user_id,
        user_table_id: user_table_id,
        create_user_id: lg_user_id,
        create_user_table_id: lg_user_table_id,
        container_id: container_id,
        blob_details: [
          {
            upload_type_id: regCUploadTypes.REG_C_PHOTO_UPLOADS.id,
            blob_ids: handleBlobsDetailPhoto?.typeIds,
          },
          {
            upload_type_id: regCUploadTypes.REG_C_OTHER_UPLOADS.id,
            blob_ids: handleBlobsDetailOther?.typeIds,
          },
        ],
      };
      await StudentService.addRegUploads(JSON.stringify(obj));
      // sweetStatusAlert(namespace.SUCCESS, `File uploaded successfully!!!`, "success")
    } catch (e) {
    } finally {
    }
  };

  render() {
    const {
      isLoading,
      full_name,
      first_name,
      last_name,
      user_code,
      gender,
      dob,
      nic,
      mobile,
      email,
      home,
      status,
      disbaleAllApplicatInputs,
      disableApprove,
      parent_name,
      parent_email,
      parent_number,
      school,
      reg_note,
      stream,
    } = this.state;

    const { isAddStudentModalOpen, toggleAddStudentModal } = this.props;
    return (
      <>
        <Modal
          size="xl"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={isAddStudentModalOpen}
          onHide={() =>
            this.handleSweetAlert(toggleAddStudentModal, "showInsertModal")
          }
        >
          <Modal.Header closeButton>
            <Modal.Title centered={true}>
              <img
                alt="Logo"
                className="logo"
                src={Levasto_Logo}
                style={{ width: "60px", height: "auto" }}
              />
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Backdrop
              sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={isLoading}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
            <Form>
              <Grid container spacing={5} rowSpacing={5}>
                {[lightTheme].map((theme, index) => (
                  <ThemeProvider theme={theme} key={index}>
                    <Grid item xs={12}>
                      <Item elevation={8}>

                        <Grid
                          container
                          spacing={2}
                          alignItems="center"
                          sx={{ p: 2 }}
                        >
                            <Grid item xs={12}>
                            <Typography
                              variant="h6"
                              sx={{ fontWeight: "bold" }}
                            >
                              Application of Admission
                            </Typography>
                          </Grid>
                          <Grid item xs={12}>
                            <List
                              sx={{
                                width: "100%",
                                maxWidth: 160,
                                bgcolor: "background.paper",
                              }}
                              subheader={
                                <ListSubheader sx={{ fontWeight: "bold" }}>
                                  1. Name of the Student
                                </ListSubheader>
                              }
                            ></List>

                            <Item elevation={0} sx={{ pl: 5, pr: 5 }}>
                            <BlockLetterInput
                                length={60}
                                values={full_name}
                                setValues={this.handleBlockInputChangeFullName}
                                label="Full Name"
                                validationMessage={this.validator.message(
                                  "full_name",
                                  this.convertArrayToString(full_name),
                                  "alpha_space",
                                  {
                                    className: "text-danger",
                                  }
                                )}
                                disbaleAllApplicatInputs={
                                  disbaleAllApplicatInputs
                                }
                              />

                              <BlockLetterInput
                                length={20}
                                values={first_name}
                                setValues={this.handleBlockInputChangeFirstName}
                                label="First Name*"
                                validationMessage={this.validator.message(
                                  "first_name",
                                  this.convertArrayToString(first_name),
                                  "required|alpha_space",
                                  {
                                    className: "text-danger",
                                    messages: {
                                      required:
                                        "The student first name is required.",
                                    },
                                  }
                                )}
                                disbaleAllApplicatInputs={
                                  disbaleAllApplicatInputs
                                }
                              />

                              <BlockLetterInput
                                length={20}
                                values={last_name}
                                setValues={this.handleBlockInputChangeLastName}
                                label="Last Name*"
                                validationMessage={this.validator.message(
                                  "last_name",
                                  this.convertArrayToString(last_name),
                                  "required|alpha_space",
                                  {
                                    className: "text-danger",
                                    messages: {
                                      required:
                                        "The student last name is required.",
                                    },
                                  }
                                )}
                                disbaleAllApplicatInputs={
                                  disbaleAllApplicatInputs
                                }
                              />
                            </Item>

                            <List
                              sx={{
                                width: "100%",
                                maxWidth: 200,
                                bgcolor: "background.paper",
                              }}
                              subheader={
                                <ListSubheader sx={{ fontWeight: "bold" }}>
                                  2. Personal & Contact Details
                                </ListSubheader>
                              }
                            ></List>

                            <Item elevation={0} sx={{ pl: 5, pr: 5 }}>
                              <Grid
                                container
                                spacing={1}
                                alignItems="center"
                                sx={{ pl: 5, pr: 5 }}
                              >
                                <Grid item xs={6}>
                                  <Grid
                                    container
                                    spacing={0.5}
                                    alignItems="center"
                                  >
                                    <Grid item xs={6}>
                                      <Item
                                        elevation={0}
                                        sx={{
                                          lineHeight: "20px",
                                          padding: "4px 0",
                                          fontWeight: "bold",
                                          backgroundColor: "#E0E8ED",
                                        }}
                                      >
                                        Date Of Birth*
                                      </Item>
                                    </Grid>

                                    <Grid item xs={6}>
                                      <Item
                                        elevation={0}
                                        sx={{
                                          lineHeight: "20px",
                                          padding: "4px 0",
                                          fontWeight: "bold",
                                          backgroundColor: "#E0E8ED",
                                        }}
                                      >
                                        Gender*
                                      </Item>
                                    </Grid>

                                    

                                    <Grid item xs={6}>
                                      <Item
                                        elevation={0}
                                        sx={{
                                          lineHeight: "20px",
                                          padding: "4px 0",
                                          fontWeight: "bold",
                                          backgroundColor: "#E0E8ED",
                                        }}
                                      >
                                        <TextField
                                          id="dob"
                                          type="date"
                                          value={dob}
                                          name="dob"
                                          onChange={this.handleChange}
                                          size="small"
                                          sx={{
                                            maxHeight: "20px",
                                            width: "100%",
                                          }}
                                          disabled={disbaleAllApplicatInputs}
                                        />
                                        <br></br>
                                        <br />
                                        <div style={{ textAlign: "left" }}>
                                          {this.validator.message(
                                            "dob",
                                            dob,
                                            "required|dateBefore",
                                            {
                                              className: "text-danger",
                                              messages: {
                                                required:
                                                  "The date of birth is required.",
                                              },
                                            }
                                          )}
                                        </div>
                                      </Item>
                                    </Grid>

                                    <Grid item xs={6}>
                                      <Item
                                        elevation={0}
                                        sx={{
                                          lineHeight: "20px",
                                          fontWeight: "bold",
                                          backgroundColor: "#E0E8ED",
                                        }}
                                      >
                                        <FormControl sx={{ height: "100%" }}>
                                          <RadioGroup
                                            row
                                            name="gender"
                                            value={gender}
                                            onChange={this.handleChange}
                                          >
                                            <FormControlLabel
                                              sx={{ height: "20px" }}
                                              value="female"
                                              label="Female"
                                              control={
                                                <Radio
                                                  sx={{ height: "10px" }}
                                                />
                                              }
                                              disabled={
                                                disbaleAllApplicatInputs
                                              }
                                            />
                                            <FormControlLabel
                                              sx={{ height: "20px" }}
                                              value="male"
                                              label="Male"
                                              control={
                                                <Radio
                                                  sx={{ height: "10px" }}
                                                />
                                              }
                                              disabled={
                                                disbaleAllApplicatInputs
                                              }
                                            />
                                          </RadioGroup>
                                        </FormControl>
                                        <div style={{ textAlign: "left" }}>
                                          {this.validator.message(
                                            "gender",
                                            gender,
                                            "required",
                                            {
                                              className: "text-danger",
                                            }
                                          )}
                                        </div>
                                      </Item>
                                    </Grid>
                                  </Grid>
                                </Grid>

                                <Grid item xs={6}>
                                  <Grid
                                    container
                                    spacing={0.5}
                                    alignItems="center"
                                  >
                                    <Grid item xs={6}>
                                      <Item
                                        elevation={0}
                                        sx={{
                                          lineHeight: "20px",
                                          padding: "4px 0",
                                          fontWeight: "bold",
                                          backgroundColor: "#E0E8ED",
                                        }}
                                      >
                                        NIC / Passport No
                                      </Item>
                                    </Grid>
                                    <Grid item xs={6}>
                                      <Item
                                        elevation={0}
                                        sx={{
                                          lineHeight: "20px",
                                          padding: "4px 0",
                                          fontWeight: "bold",
                                          backgroundColor: "#E0E8ED",
                                        }}
                                      >
                                        <TextField
                                          value={nic}
                                          onChange={this.handleChange}
                                          size="small"
                                          name="nic"
                                          id="outlined-basic"
                                          label="NIC / Passport No"
                                          variant="outlined"
                                          disabled={disbaleAllApplicatInputs}
                                        />
                                        <div style={{ textAlign: "left" }}>
                                        {this.validator.message(
                                            "nic",
                                            nic,
                                            "max:12",
                                            {
                                            className: "text-danger",
                                            messages: {
                                                max: "The student NIC must be no longer than 12 characters.",
                                            },
                                            }
                                        )}
                                        </div>
                                      </Item>
                                    </Grid>
                                  </Grid>
                                </Grid>

                                <Grid item xs={6}>
                                  <Item
                                    elevation={0}
                                    sx={{
                                      lineHeight: "20px",
                                      padding: "4px 0",
                                      fontWeight: "bold",
                                      backgroundColor: "#E0E8ED",
                                    }}
                                  >
                                    <TextField
                                      onChange={this.handleChange}
                                      name="mobile"
                                      value={mobile}
                                      fullWidth
                                      id="outlined-basic"
                                      label="Contact Number*"
                                      variant="outlined"
                                      disabled={disbaleAllApplicatInputs}
                                    />
                                    <div style={{ textAlign: "left" }}>
                                      {this.validator.message(
                                        "mobile",
                                        mobile,
                                        "required|numeric|min:9|max:12",
                                        {
                                          className: "text-danger",
                                          messages: {
                                            required:
                                              "The contact number is required.",
                                            numeric:
                                              "The contact number must contain only numbers.",
                                            min: "The contact number must be at least 9 numbers.",
                                            max: "The contact number cannot exceed 12 numbers.",
                                          },
                                        }
                                      )}
                                    </div>
                                  </Item>
                                </Grid>

                               
                                <Grid item xs={6}>
                                  <Item
                                    elevation={0}
                                    sx={{
                                      lineHeight: "20px",
                                      padding: "4px 0",
                                      fontWeight: "bold",
                                      backgroundColor: "#E0E8ED",
                                    }}
                                  >
                                    <TextField
                                      onChange={this.handleChange}
                                      name="school"
                                      value={school}
                                      fullWidth
                                      id="outlined-basic"
                                      label="School*"
                                      variant="outlined"
                                      disabled={disbaleAllApplicatInputs}
                                    />
                                    <div style={{ textAlign: "left" }}>
                                      {this.validator.message(
                                        "school",
                                        school,
                                        "required",
                                        {
                                          className: "text-danger",
                                          messages: {
                                            required:
                                              "The school is required.",
                                          },
                                        }
                                      )}
                                    </div>
                                  </Item>
                                </Grid>
                               

                                <Grid item xs={6}>
                                  <Item
                                    elevation={0}
                                    sx={{
                                      lineHeight: "20px",
                                      padding: "4px 0",
                                      fontWeight: "bold",
                                      backgroundColor: "#E0E8ED",
                                    }}
                                  >
                                    <TextField
                                      onChange={this.handleChange}
                                      name="email"
                                      value={email}
                                      fullWidth
                                      id="outlined-basic"
                                      label="Email*"
                                      variant="outlined"
                                      disabled={disbaleAllApplicatInputs}
                                    />
                                    <div style={{ textAlign: "left" }}>
                                      {this.validator.message(
                                        "email",
                                        email,
                                        "required|email|max:150",
                                        {
                                          className: "text-danger",
                                          messages: {
                                            required: "The email is required.",
                                            max: "Email must be less than 150 characters.",
                                          },
                                        }
                                      )}
                                    </div>
                                  </Item>
                                </Grid>

                               

                                <Grid item xs={6}>
                                  <Item
                                    elevation={0}
                                    sx={{
                                      lineHeight: "20px",
                                      padding: "4px 0",
                                      fontWeight: "bold",
                                      backgroundColor: "#E0E8ED",
                                    }}
                                  >
                                    <TextField
                                      onChange={this.handleChange}
                                      name="stream"
                                      value={stream}
                                      fullWidth
                                      id="outlined-basic"
                                      label="Background/ Stream*"
                                      variant="outlined"
                                      disabled={disbaleAllApplicatInputs}
                                    />
                                    <div style={{ textAlign: "left" }}>
                                      {this.validator.message(
                                        "stream",
                                        stream,
                                        "required|max:200",
                                        {
                                          className: "text-danger",
                                          messages: {
                                            required:
                                              "Background/ Stream is required.",
                                            max: "Background/ Stream must be less than 200 characters.",
                                          },
                                        }
                                      )}
                                    </div>
                                  </Item>
                                </Grid>

                               
                                <Grid item xs={6}>
                                  <Item
                                    elevation={0}
                                    sx={{
                                      lineHeight: "20px",
                                      padding: "4px 0",
                                      fontWeight: "bold",
                                      backgroundColor: "#E0E8ED",
                                    }}
                                  >
                                    <TextField
                                      onChange={this.handleChange}
                                      name="home"
                                      value={home}
                                      fullWidth
                                      id="outlined-basic"
                                      label="Home Address*"
                                      variant="outlined"
                                      disabled={disbaleAllApplicatInputs}
                                    />
                                    <div style={{ textAlign: "left" }}>
                                      {this.validator.message(
                                        "home",
                                        home,
                                        "required|max:200",
                                        {
                                          className: "text-danger",
                                          messages: {
                                            required:
                                              "Home address is required.",
                                            max: "Home address must be less than 200 characters.",
                                          },
                                        }
                                      )}
                                    </div>
                                  </Item>
                                </Grid>
                              </Grid>
                            </Item>


                            <List
                              sx={{
                                width: "100%",
                                minWidth: 200,
                                textAlign: "left", 
                                bgcolor: "background.paper",
                              }}
                              subheader={
                                <ListSubheader sx={{ fontWeight: "bold" }}>
                                  3. Parent/ Guardian Contact Details
                                  </ListSubheader>
                              }
                            ></List>

                            <Item elevation={0} sx={{ pl: 5, pr: 5 }}>
                              <Grid
                                container
                                spacing={1}
                                alignItems="center"
                                sx={{ pl: 5, pr: 5 }}
                              >
        
                                <Grid item xs={6}>
                                  <Item
                                    elevation={0}
                                    sx={{
                                      lineHeight: "20px",
                                      padding: "4px 0",
                                      fontWeight: "bold",
                                      backgroundColor: "#E0E8ED",
                                    }}
                                  >
                                    <TextField
                                      onChange={this.handleChange}
                                      name="parent_name"
                                      value={parent_name}
                                      fullWidth
                                      id="outlined-basic"
                                      label="Parent/Guardian Name"
                                      variant="outlined"
                                      disabled={disbaleAllApplicatInputs}
                                    />
                                    
                                  </Item>
                                </Grid>

                                <Grid item xs={6}>
                                  <Item
                                    elevation={0}
                                    sx={{
                                      lineHeight: "20px",
                                      padding: "4px 0",
                                      fontWeight: "bold",
                                      backgroundColor: "#E0E8ED",
                                    }}
                                  >
                                    <TextField
                                      onChange={this.handleChange}
                                      name="parent_email"
                                      value={parent_email}
                                      fullWidth
                                      id="outlined-basic"
                                      label="Parent/Guardian Email"
                                      variant="outlined"
                                      disabled={disbaleAllApplicatInputs}
                                    />
                                    <div style={{ textAlign: "left" }}>
                                      {this.validator.message(
                                        "parent_email",
                                        parent_email,
                                        "email|max:150",
                                        {
                                          className: "text-danger",
                                          messages: {
                                            max: "Email must be less than 150 characters.",
                                          },
                                        }
                                      )}
                                    </div>
                                  </Item>
                                </Grid>

                                <Grid item xs={6}>
                                  <Item
                                    elevation={0}
                                    sx={{
                                      lineHeight: "20px",
                                      padding: "4px 0",
                                      fontWeight: "bold",
                                      backgroundColor: "#E0E8ED",
                                    }}
                                  >
                                    <TextField
                                      onChange={this.handleChange}
                                      name="parent_number"
                                      value={parent_number}
                                      fullWidth
                                      id="outlined-basic"
                                      label="Parent/Guardian Contact Number*"
                                      variant="outlined"
                                      disabled={disbaleAllApplicatInputs}
                                    />
                                    <div style={{ textAlign: "left" }}>
                                      {this.validator.message(
                                        "parent_number",
                                        parent_number,
                                        "numeric|min:9|max:12",
                                        {
                                          className: "text-danger",
                                          messages: {
                                            numeric:
                                              "The contact number must contain only numbers.",
                                            min: "The contact number  must be at least 9 numbers.",
                                            max: "The contact number cannot exceed 12 numbers.",
                                          },
                                        }
                                      )}
                                    </div>
                                  </Item>
                                </Grid>
                              </Grid>
                            </Item>
                          </Grid>
                        </Grid>

 

                        <Grid
                          container
                          spacing={2}
                          alignItems="center"
                          sx={{ p: 2 }}
                        >
                        </Grid>
                      </Item>
                    </Grid>
                    <Grid item xs={12}>
                      <Item elevation={8}>
                        <Grid
                          container
                          spacing={2}
                          alignItems="center"
                          sx={{ p: 2 }}
                        >
                          <Grid item xs={12}>
                            <RegCDocSubmission
                              disbaleAllApplicatInputs={
                                disbaleAllApplicatInputs
                              }
                              uploadFiles={this.state.uploadFiles}
                              handleUploadFiles={this.handleUploadFiles}
                            />
                          </Grid>
                         
                        </Grid>
                      </Item>
                    </Grid>

                    {this.state.officeSectionAvailability && <Grid item xs={12}>
                      <Item elevation={8}>
                        <Grid
                          container
                          spacing={2}
                          alignItems="center"
                          sx={{ p: 2 }}
                        >

                                <Grid item xs={12}>
                            <Item elevation={0} sx={{ pl: 5, pr: 5 }}>
                              <TextField
                                value={reg_note}
                                onChange={this.handleChange}
                                multiline
                                rows={5}
                                name="reg_note"
                                fullWidth
                                id="outlined-textarea"
                                label="Registration Note"
                                variant="outlined"
                                disabled={disableApprove}
                              />
                              <div style={{ textAlign: "left" }}>
                                      {this.validator.message(
                                        "reg_note",
                                        reg_note,
                                        "max:1000",
                                        {
                                          className: "text-danger",
                                          messages: {
                                            max: "Registration Note must be less than 1000 characters.",
                                          },
                                        }
                                      )}
                                    </div>
                            </Item>
                          </Grid>
                         

                            <Grid item xs={12}>
                              <Item elevation={0} sx={{ pl: 5, pr: 5 }}>
                                <FormControl sx={{ height: "100%" }}>
                                  

                                  <RadioGroup
                                    row
                                    name="status"
                                    value={status}
                                    onChange={this.handleChange}
                                    disabled={disableApprove}
                                  >
                                    <FormControlLabel
                                      sx={{ height: "20px" }}
                                      value={1}
                                      label="Active"
                                      control={
                                        <Radio
                                          disabled={disableApprove}
                                          sx={{ height: "10px" }}
                                        />
                                      }
                                    />
                                    <FormControlLabel
                                      sx={{ height: "20px" }}
                                      value={0}
                                      label="Inactive"
                                      control={
                                        <Radio
                                          disabled={disableApprove}
                                          sx={{ height: "10px" }}
                                        />
                                      }
                                    />
                                  </RadioGroup>
                                </FormControl>
                              </Item>
                            </Grid>

                          
                          </Grid>
                        </Item>
                      </Grid>
                    }

                    <Grid item xs={12}>
                      <Item elevation={0}>
                        <Button
                          variant="contained"
                          size="large"
                          onClick={this.handleSubmit}
                        >
                          Submit
                        </Button>
                      </Item>
                    </Grid>
                  </ThemeProvider>
                ))}
              </Grid>
            </Form>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}
